import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../customHooks/useAuth'
import axios from '../../utils/axios'

export default function Logout({ redirect = '/sign-in' }: { redirect: string }) {
  const { logout, user } = useAuth()
  const navigate = useNavigate()
  const logoutInitiated = useRef(false)

  const callLogoutAPI = async () => {
    if (!user?.tokens?.accessToken?.token) return

    const url = `${process.env.REACT_APP_BASE_URL}/api/auth/signout`
    try {
      const config = {
        method: 'POST',
        url,
        headers: user?.isSSO
          ? {
              'x-user': user?.email,
              'x-access-token': user?.tokens?.accessToken?.token,
              'x-source': 'sso',
            }
          : {
              'x-user': user?.email,
              'x-access-token': user?.tokens?.accessToken?.token,
            },
      }
      await axios(config)
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        throw error?.response ?? error
      }
      throw error
    }
  }

  useEffect(() => {
    if (logoutInitiated.current) {
      return
    }

    logoutInitiated.current = true

    callLogoutAPI()
    logout()
    // window.location.replace(redirect)

    // // Push the logout route, and then replace it — clears current history
    window.history.pushState(null, '', redirect)
    window.history.replaceState(null, '', redirect)
    navigate(redirect, { replace: true })

    // Prevent back navigation
    const handlePopState = () => {
      window.history.pushState(null, '', redirect)
    }
    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [logout, navigate])

  return null
}
